import { Pipe } from '@angular/core';
import { Drug, MedicalTest } from '../models';

@Pipe({
  name: 'buttonText'
})
export class ButtonTextPipe {
  transform(
    data: {cartItems: (MedicalTest | Drug)[], isDrugUpdate?: boolean}, 
    product: MedicalTest | Drug ) {
    return data.isDrugUpdate ? 'Update Cart' : data.cartItems.some(item => item.id === product.id) ? 'Remove' : 'Add to cart';
  }
}
